module.exports = __webpack_public_path__ + "img/DatabaseConnected.5fdcb4db.svg";